import { useEffect, useState } from "react";
import {
  useMediaQuery,
  Box,
  Flex,
  SkeletonText,
  Skeleton,
} from "@chakra-ui/react";
import { colors } from "../../definitions/constants/GlobalStyles";
import {
  PostApiResponse,
  PostData,
} from "../../definitions/interfaces/GlobalInterfaces";
import i18n from "../../i18n/i18n";
import { consumeApi, languageTag } from "../../utils/tools";
import AuthorInfoComponent from "./AuthorInfoComponent";
import PostItemComponent from "./PostItemComponent";
import SendCommentsComponent from "./SendCommentsComponent";
import CommentsListComponent from "./CommentsListComponent";
import CommentsModalComponent from "./CommentsModalComponent";
import ShareCountComponent from "./ShareCountComponent";
import SharePostModalComponent from "./SharePostModalComponent";
import { useNavigate } from "react-router-dom";
import { appStore } from "../../zustand/globalStore";

function PostComponent() {
  const [isMobile] = useMediaQuery("(max-width: 992px)");
  const [apiResponse, setApiResponse] = useState<PostApiResponse>();
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);

  const navigate = useNavigate();
  const { userData } = appStore((state) => state);

  let firstLoad = false;

  let requestBody = {
    page: page,
    user_id: "anonymous",
    language: {
      languageCode: i18n.language,
      languageTag: languageTag[i18n.language]
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      console.log({
        languageCode: i18n.language,
        languageTag: languageTag[i18n.language]
      })
      let data = await consumeApi(`posts/get_posts`, "POST", requestBody);
      data = data.data.filter((data: any) => !!data?.local_media || !!data?.media_url);

      setTimeout(() => {
        setApiResponse((prevState) => ({
          ...data,
          data: [...(prevState?.data || []), ...data],
        }));
        setLoader(false);
      }, 1000);
    } catch (error) {
    } finally {
      if (page <= 1) {
        firstLoad = true;
      }
    }
  };

  useEffect(() => {
    if (page < 4) {
      fetchData();
    }
  }, [page]);

  const nextPage = async () => {
    if (
      firstLoad &&
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", nextPage);
    return () => window.removeEventListener("scroll", nextPage);
  }, []);

  return (
    <>
      {apiResponse && apiResponse?.data.length > 0 ? (
        <div>
          {apiResponse?.data.map((post: PostData) => (
            <PostItemComponent key={post.id} post={post} />
          ))}
        </div>
      ) : (
        !loader && (
          <Box pt={10} textAlign="center" color="gray.500">
            {i18n.t("noResults")}
          </Box>
        )
      )}

      {loader ? (
        <Box
          display="flex"
          gap="10px"
          width="100%"
          flexDirection="column"
          marginTop={isMobile ? "0" : "25px"}
        >
          {Array.from({ length: 3 }).map((_, index) => (
            <Flex
              padding="6"
              boxShadow="sm"
              width="100%"
              display="flex"
              key={index}
              gap="10px"
              borderRadius={"20px"}
              bg={isMobile ? "transparent" : colors.text.white}
              direction={isMobile ? "column" : "row"}
              marginBottom={4}
            >
              <Box width={"100%"}>
                <Skeleton height="300px" borderRadius="20px" width="100%" />
              </Box>
              <Box
                width={"100%"}
                display="flex"
                flexDirection="column"
                justifyContent="start"
              >
                <SkeletonText width="20%" noOfLines={1} marginBottom={"10px"} />
                <SkeletonText noOfLines={4} />
              </Box>
            </Flex>
          ))}
        </Box>
      ) : null}

      <CommentsModalComponent post={null} />
      <SharePostModalComponent />
    </>
  );
}

export default PostComponent;
